import { Button, Col, Form, Input, Row, Space, theme, Table, Select, DatePicker, Tooltip, Segmented, Progress, message, Tag } from 'antd';
import React, { useEffect, useState } from 'react';
import LoadingBase from '../../components/LoadingBase';
import '../../css/listbook-page.css';
import { DATE_FORMAT, FORMAT_DATE, HeaderTableCus, LIST_SEX, OPTION_TIME, STATUS_ORDER, STATUS_SERVICES, STATUS_USAGE, TYPE_TICKET } from '../../constants/constants';
import { PlusCircleFilled, SearchOutlined } from '@ant-design/icons';
import { filterOption, formatNumber, getSelectedBranch } from '../../utils/funcHelper';
import dayjs from 'dayjs';
import { consoleLogUtil } from '../../utils/consoleLogUtil';
import { useSelector } from 'react-redux';
import RegisterServiceModal from './modal/RegisterServiceModal';
import { customer_services_active_list, customer_services_create, customer_services_detail, customer_services_update_status, customers_create, employees_list, get_total_revenue, getListBranches, positions_with_rules, services_list } from '../../services/apis';
import ServiceDetailModal from './modal/ServiceDetailModal';

const ManagerRegisterServicesPage = () => {
    const { token } = theme.useToken();
    const [form] = Form.useForm();

    const initialValues = {
        keyword: '',
        status: null,
        date: [dayjs().startOf('day'), dayjs().endOf('day')],
        branch_id: getSelectedBranch()?.id ?? null,
    };

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [itemSelected, setItemSelected] = useState();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageSize, setCurrentPageSize] = useState(20);
    const [totalRecords, setTotalRecords] = useState(0);
    const userReducer = useSelector((state) => state?.userReducer?.data);
    const [optionTime, setOptionTime] = useState(1);
    const [providers, setProviders] = useState([]);
    const [employees, setEmployees] = useState([]);
    const [dataServices, setDataServices] = useState([]);
    const [isShowModalDetailService, setIsShowModalDetailService] = useState(false);
    const [dataPositions, setDataPositions] = useState([]);
    const [dataBranches, setDataBranches] = useState([]);
    const [revenueStatistics, setRevenueStatistics] = useState(null);
    const { RangePicker } = DatePicker;
    const twoColors = {
        '0%': '#108ee9',
        '100%': '#87d068',
    };
    const columns = [
        {
            title: 'STT',
            align: 'center',
            width: 60,
            render: (text, record, index) => <div>{(currentPage - 1) * currentPageSize + index + 1}</div>,
        },
        {
            title: 'Tên dịch vụ',
            dataIndex: 'service_name',
            key: 'service_name',
            width: 200,
            render: (text, record, index) => <div>
                <a style={{ paddingLeft: 0, paddingRight: 8 }}>{text}</a>
            </div>,
        },
        {
            title: 'Tên khách hàng',
            dataIndex: 'customer_name',
            key: 'customer_name',
            width: 200,
            render: (text, record, index) => <div
                style={{
                    paddingLeft: 0, paddingRight: 12
                }}>
                {text}
            </div>,
        },
        {
            title: 'Loại',
            dataIndex: 'type',
            key: 'type',
            width: 100,
            align: 'center',
            render: (text, record, index) => <div>
                {TYPE_TICKET.find(item => item.value === text)?.label ?? ''}
            </div>,
        },
        {
            title: 'Thành tiền',
            dataIndex: 'total_amount',
            key: 'total_amount',
            align: 'right',
            width: 120,
            render: (text, record, index) => <div>
                {formatNumber(parseInt(text), 0)}
            </div>,
        },
        {
            title: 'Tổng số buổi',
            dataIndex: 'total_sessions',
            key: 'total_sessions',
            align: 'center',
            width: 120,
            render: (text, record, index) => <div>
                {text} buổi
            </div>,
        },
        {
            title: 'Đã sử dụng',
            dataIndex: 'percent_used',
            key: 'percent_used',
            width: 180,
            render: (text, record, index) =>
                <Progress
                    percent={parseInt(text)}
                    status='active'
                    percentPosition={{ align: 'center', type: 'inner' }}
                    size={[180, 16]}
                    style={{ fontSize: 11 }}
                    strokeColor={twoColors}
                />

        },

        {
            title: 'Trạng thái',
            align: 'center',
            dataIndex: 'status',
            key: 'status',
            width: 100,
            render: (text, record, index) => renderStatus(text)
        },
        {
            title: 'Tình trạng',
            dataIndex: 'status_usage',
            key: 'status_usage',
            align: 'center',
            width: 120,
            render: (text, record, index) => <div>
                {(text === "valid" || text === 'unlimited') ? <span style={{ color: 'green' }}>Còn hạn</span> : <span style={{ color: 'red' }}>Hết hạn</span>}
            </div>,
        },
        {
            title: 'Ngày hết hạn',
            dataIndex: 'end_date',
            key: 'end_date',
            width: 120,
            align: 'center',
            render: (text, record, index) => <div>{text ? dayjs(text).format(FORMAT_DATE.DDMMYYYY) : 'Không thời hạn'}</div>,
        },
        {
            title: 'Ngày đăng ký',
            dataIndex: 'regis_date',
            key: 'regis_date',
            width: 150,
            align: 'center',
            render: (text, record, index) => <div>{dayjs(text).format(FORMAT_DATE.DDMMYYYYHHMMSS)}</div>,
        },
        {
            title: 'Ngày tạo',
            dataIndex: 'created_at',
            key: 'created_at',
            width: 150,
            align: 'center',
            render: (text, record, index) => <div>{dayjs(text).format(FORMAT_DATE.DDMMYYYY)}</div>,
        },
    ];
    const formStyle = {
        maxWidth: 'none',
        background: 'white',
        borderRadius: token.borderRadiusLG,
        paddingLeft: 0,
        paddingRight: 0,
        marginBottom: 12,
    };

    const renderStatus = (status) => {
        const statusObj = STATUS_SERVICES.find(item => item.value === status);
        if (statusObj) {
            let color = 'default';
            switch (status) {
                case STATUS_SERVICES[0].value:
                    color = 'orange';
                    break;
                case STATUS_SERVICES[1].value:
                    color = 'green';
                    break;
                case STATUS_SERVICES[2].value:
                    color = 'red';
                    break;
                default:
                    color = 'default';
            }
            return <Tag color={color} key={status}>
                {statusObj.label}
            </Tag>;
        }
        return <Tag key={status}>{status}</Tag>;
    }

    const getDataServices = async () => {
        try {
            const params = {
                keyword: '',
            }
            const res = await services_list(params);
            if (res && res.status === 1) {
                setDataServices([...res?.data?.map(item => ({ ...item, value: item.id, label: item.name }))]);
            } else {
                setDataServices([]);
            }
        } catch (error) {
            console.log('error', error);
        }
    }

    const getDataServiceDetail = async (service_id) => {

        try {
            const params = {
                id: service_id,
            }
            setLoading(true);
            const res = await customer_services_detail(params);
            if (res && res.status === 1) {
                setItemSelected(res?.data);
                setIsShowModalDetailService(true);
            } else {
                message.error(res.msg || 'Có lỗi xảy ra, vui lòng thử lại');
            }
        } catch (error) {
            consoleLogUtil("error", error);
        } finally {
            setLoading(false);
        }

    }


    const handleChangeOptionTime = (value) => {
        setOptionTime(value);
        switch (value) {
            case 1:
                form.setFieldsValue({
                    date: [dayjs().startOf('day'), dayjs().endOf('day')]
                });
                break;
            case 2:
                form.setFieldsValue({
                    date: [dayjs().startOf('day').subtract(1, 'day'), dayjs().endOf('day').subtract(1, 'day')]
                });
                break;
            case 3:
                form.setFieldsValue({
                    date: [dayjs().startOf('day').subtract(7, 'day'), dayjs().endOf('day')]
                });
                break;
            case 4:
                form.setFieldsValue({
                    date: [dayjs().startOf('month'), dayjs().endOf('day')]
                });
                break;
            case 5:
                form.setFieldsValue({
                    date: [
                        dayjs().subtract(1, 'month').startOf('month'),
                        dayjs().subtract(1, 'month').endOf('month')
                    ]
                });
                break;
        }
        setCurrentPage(1);
        getDataRegistedSevices(1, dayjs(form.getFieldValue("date")[0]).format(DATE_FORMAT.YYYYMMDDHHMMSS_FORMAT), dayjs(form.getFieldValue("date")[1]).format(DATE_FORMAT.YYYYMMDDHHMMSS_FORMAT), true);
        getDataRevenueStatistics();
    }

    const getDataRevenueStatistics = async () => {
        try {
            const params = {
                keyword: form.getFieldValue('keyword') ?? '',
                service_id: form.getFieldValue('service_id') ?? null,
                branch_id: form.getFieldValue('branch_id') ?? null,
                status_usage: form.getFieldValue('expired') ?? null,
                status: form.getFieldValue('status') ?? null,
                start_date: dayjs(form.getFieldValue("date")[0]).format(DATE_FORMAT.YYYYMMDDHHMMSS_FORMAT),
                end_date: dayjs(form.getFieldValue("date")[1]).format(DATE_FORMAT.YYYYMMDDHHMMSS_FORMAT),
                user_id: userReducer?.user_info?.id,
            }
            setLoading(true);
            const res = await get_total_revenue(params);
            setLoading(false);
            consoleLogUtil("res get_total_revenue", res);
            if (res && res.status === 1) {
                setRevenueStatistics(res?.data?.revenue_summary?.total_actual);
            } else {
                setRevenueStatistics(0);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const getDataRegistedSevices = async (page, startTime, endTime, showLoading, pageSize) => {
        try {
            const params = {
                keyword: form.getFieldValue('keyword') ?? '',
                service_id: form.getFieldValue('service_id') ?? null,
                branch_id: form.getFieldValue('branch_id') ?? null,
                status_usage: form.getFieldValue('expired') ?? null,
                status: form.getFieldValue('status') ?? null,
                start_date: startTime,
                end_date: endTime,
                page: page ?? currentPage,
                limit: pageSize ?? currentPageSize,
                user_id: userReducer?.user_info?.id,
            }
            if (showLoading) setLoading(true);
            const res = await customer_services_active_list(params);
            if (showLoading) setLoading(false);
            consoleLogUtil("res customer_services_active_list", res);
            if (res && res.status === 1) {
                setData([...res?.data?.data]);
                setTotalRecords(res?.data?.pagination?.total_records ?? 0);
            } else {
                message.error(res.msg || 'Có lỗi xảy ra, vui lòng thử lại');
                setData([]);
                setTotalRecords(0);
            }
        } catch (error) {

        }
    }

    const getPositionWithRules = async () => {
        try {
            const res = await positions_with_rules();
            consoleLogUtil("res positions_with_rules", res);
            if (res && res.status === 1) {
                setDataPositions([...res?.data?.map(item => ({ ...item, value: item.id, label: item.name }))]);
            } else {
                setProviders([]);
            }
        } catch (error) {
            console.log('error', error);
        }
    }

    const getDataEmployees = async (keyword) => {
        try {
            const params = {
                keyword: keyword,
                branch_id: null,
                limit: 100,
                currentPage: 1,
            }
            const res = await employees_list(params);
            if (res && res.status === 1) {
                setEmployees([...res?.data?.data?.map(item => ({ ...item, value: item.id, label: item.full_name }))]);
            } else {
                setEmployees([]);
            }
        } catch (error) {
            setLoading(false);
            console.log('error', error);
        }
    }

    const onFinish = async (dataForm) => {
        setCurrentPage(1);
        getDataRegistedSevices(1, dayjs(form.getFieldValue("date")[0]).format(DATE_FORMAT.YYYYMMDDHHMMSS_FORMAT), dayjs(form.getFieldValue("date")[1]).endOf('date').format(DATE_FORMAT.YYYYMMDDHHMMSS_FORMAT), true);
        getDataRevenueStatistics();
    };

    const callAPIRegisterService = async (lstServices) => {
        const params = {
            services: lstServices,
            created_by: userReducer?.user_info?.id,
        }
        const resServices = await customer_services_create(params);
        if (resServices && resServices.status === 1) {
            message.success('Đăng ký dịch vụ thành công');
            getDataRegistedSevices(1, dayjs(form.getFieldValue("date")[0]).format(DATE_FORMAT.YYYYMMDDHHMMSS_FORMAT), dayjs(form.getFieldValue("date")[1]).endOf('date').format(DATE_FORMAT.YYYYMMDDHHMMSS_FORMAT), true);
        } else {
            message.error(resServices.msg || 'Có lỗi xảy ra, vui lòng thử lại');
        }
    }

    const handleOnRegisterService = async (data) => {
        // Nếu khách hàng mới
        if (data?.isNewCustomer) {
            // Call API tạo mới khách hàng
            // Nếu tạo mới khách hàng thành công thì call API tạo đơn dịch vụ
            try {
                const paramsCreateCustomer = {
                    full_name: data?.full_name,
                    phone: data?.phone,
                    birthday: data?.birth_day ?? null,
                    address: data?.address ?? '',
                    gender: data?.gender ?? LIST_SEX[1].value,
                    branch_id: getSelectedBranch()?.id ?? null,
                    created_by: userReducer?.user_info?.id
                }
                setLoading(true);
                const res = await customers_create(paramsCreateCustomer);
                if (res && res.status === 1) {
                    const customer_id = res?.data?.id;
                    const branch_id = getSelectedBranch()?.id ?? null;
                    const listServices = data?.lst_services?.map(item => (
                        {
                            customer_id: customer_id,
                            service_id: item?.service_id,
                            type: item?.ticket_type,
                            start_date: item?.start_date,
                            end_date: item?.end_date ?? null,
                            total_sessions: item?.total_sessions ?? null,
                            discount_type: item?.discount_type ?? null,
                            discount_value: item?.discount ?? 0,
                            total_amount: item?.total_amount,
                            paid_amount: item?.paid_amount,
                            consultants: data?.consultant_ids ?? null,
                            sale_price: item?.sale_price ?? 0,
                            branch_id: branch_id,
                            note: item?.note ?? '',
                            regis_date: item?.regis_date,
                        }
                    ));
                    if (listServices?.length > 0) {
                        // Call API đăng ký dịch vụ cho khách hàng
                        callAPIRegisterService(listServices);
                    }

                } else {
                    message.error(res.msg || 'Có lỗi xảy ra, vui lòng thử lại');
                }
            } catch (error) {
                consoleLogUtil("error", error);
            } finally {
                setLoading(false);
            }


        } else {
            // Nếu khách hàng cũ thì chỉ call API tạo đơn dịch vụ
            try {
                const customer_id = data?.customer_id;
                const branch_id = getSelectedBranch()?.id ?? null;
                const listServices = data?.lst_services?.map(item => (
                    {
                        customer_id: customer_id,
                        service_id: item?.service_id,
                        type: item?.ticket_type,
                        start_date: item?.start_date,
                        end_date: item?.end_date ?? null,
                        total_sessions: item?.total_sessions ?? null,
                        discount_type: item?.discount_type ?? null,
                        discount_value: item?.discount ?? 0,
                        total_amount: item?.total_amount,
                        paid_amount: item?.paid_amount,
                        consultants: data?.consultant_ids ?? null,
                        sale_price: item?.sale_price ?? 0,
                        status: item?.status,
                        branch_id: branch_id,
                        note: item?.note ?? '',
                        regis_date: item?.regis_date,
                    }
                ));
                if (listServices?.length > 0) {
                    // Call API đăng ký dịch vụ cho khách hàng
                    callAPIRegisterService(listServices);
                }

            } catch (error) {
                consoleLogUtil("error", error);
            } finally {
                setLoading(false);
            }
        }

    }
    const handleSaveServiceDetail = async (data) => {
        try {
            const params = {
                id: data?.id,
                status: data?.status,
                updated_by: userReducer?.user_info?.id
            }
            setLoading(true);
            const res = await customer_services_update_status(params);
            if (res && res.status === 1) {
                message.success('Cập nhật dịch vụ thành công');
                getDataRegistedSevices(1, dayjs(form.getFieldValue("date")[0]).format(DATE_FORMAT.YYYYMMDDHHMMSS_FORMAT), dayjs(form.getFieldValue("date")[1]).endOf('date').format(DATE_FORMAT.YYYYMMDDHHMMSS_FORMAT), true);
            } else {
                message.error(res.msg || 'Có lỗi xảy ra, vui lòng thử lại');
            }
        } catch (error) {
            consoleLogUtil("error", error);
        } finally {
            setLoading(false);
        }
    }

    const getDataBranches = async () => {
        try {
            const params = {
                keyword: '',
            }
            const res = await getListBranches(params);
            if (res && res.status === 1) {
                setDataBranches([...res?.data?.data?.map(item => ({ ...item, value: item.id, label: item.name }))]);
            } else {
                setDataBranches([]);
            }
        } catch (error) {
            setLoading(false);
            console.log('error', error);
        }


    }

    useEffect(() => {
        setLoading(true);
        Promise.all([getDataEmployees(), getDataServices(), getPositionWithRules(), getDataBranches()]).finally(() => setLoading(false));
    }, [])

    useEffect(() => {
        if (form) {
            form.setFieldsValue(initialValues);
            getDataRegistedSevices(1, dayjs().startOf('day').format(DATE_FORMAT.YYYYMMDDHHMMSS_FORMAT), dayjs().endOf('day').format(DATE_FORMAT.YYYYMMDDHHMMSS_FORMAT), true);
            getDataRevenueStatistics();
        }
    }, [form])

    return (
        <div className='container-content'>

            <Form form={form} name="advanced_search" style={formStyle} onFinish={onFinish}>
                <Row gutter={24}>
                    <Col span={4}>
                        <Form.Item
                            name={'keyword'}
                        >
                            <Input
                                placeholder={'Tên khách hàng, SĐT'}
                                className='custom-input-antd'
                            />
                        </Form.Item>
                    </Col>

                    <Col span={5}>
                        <Form.Item
                            name="service_id"
                        >
                            <Select
                                showSearch
                                allowClear
                                placeholder={'Chọn dịch vụ'}
                                className='custom-input-antd'
                                defaultActiveFirstOption={false}
                                filterOption={filterOption}
                                notFoundContent={null}
                                options={dataServices}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={3}>
                        <Form.Item
                            name="branch_id"
                        >
                            <Select
                                showSearch
                                allowClear
                                placeholder={'Chọn cơ sở'}
                                className='custom-input-antd'
                                defaultActiveFirstOption={false}
                                filterOption={filterOption}
                                notFoundContent={null}
                                options={dataBranches}
                            />
                        </Form.Item>
                    </Col>
                    {/* <Col span={3}>
                        <Form.Item
                            name="expired"
                        >
                            <Select
                                showSearch
                                allowClear
                                placeholder={'Tình trạng'}
                                className='custom-input-antd'
                                defaultActiveFirstOption={false}
                                filterOption={filterOption}
                                notFoundContent={null}
                                options={STATUS_USAGE}
                            />
                        </Form.Item>
                    </Col> */}
                    <Col span={4}>
                        <Form.Item
                            name="status"
                        >
                            <Select
                                showSearch
                                allowClear
                                placeholder={'Trạng thái DV'}
                                className='custom-input-antd'
                                defaultActiveFirstOption={false}
                                filterOption={filterOption}
                                notFoundContent={null}
                                options={STATUS_SERVICES}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item
                            name="date"
                        >
                            <RangePicker
                                format={FORMAT_DATE.DDMMYYYY}
                                allowClear={false}
                                className='custom-input-antd'
                            />
                        </Form.Item>
                    </Col>

                    <Col span={2}>
                        <Space size="small">
                            <Tooltip title="Tìm kiếm">
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    className='custom-input-antd'
                                >
                                    <SearchOutlined /> Tìm
                                </Button>
                            </Tooltip>

                        </Space>
                    </Col>
                </Row>
                <Row align="middle" justify="space-between">
                    <Col>
                        <div style={{ fontWeight: 'bold', fontSize: 16, display: 'flex', alignItems: 'center' }}>
                            <span>Tổng doanh thu:</span>
                            <Tooltip title="Tổng doanh thu là bao gồm các khoản tiền khách hàng đến làm dịch vụ và khách thanh toán công nợ"><span style={{ color: 'red', marginLeft: 8 }}>{formatNumber(parseInt(revenueStatistics ?? 0), 0)} đ</span></Tooltip>
                        </div>
                    </Col>
                    <Col>
                        <Space>
                            <Button
                                type='primary'
                                icon={<PlusCircleFilled />}
                                style={{ height: 30, color: 'white', backgroundColor: '#52c41a', borderColor: '#52c41a' }}
                                onClick={() => setIsModalOpen(true)}
                            >
                                Đăng ký mới
                            </Button>
                            <Segmented
                                value={optionTime}
                                options={OPTION_TIME}
                                onChange={handleChangeOptionTime}
                            />
                        </Space>
                    </Col>
                </Row>
            </Form>

            <Table
                components={HeaderTableCus}
                columns={columns}
                dataSource={data}
                bordered
                rowKey={(record) => record?.id}
                scroll={{ x: 'max-content', y: 600 }}
                onRow={(record, rowIndex) => {
                    return {
                        onClick: event => {
                            getDataServiceDetail(record?.id);
                        }, // click row
                        onMouseEnter: event => {
                            event.currentTarget.style.cursor = 'pointer';
                        }, // hover row
                    };
                }}
                pagination={{
                    pageSize: currentPageSize,
                    current: currentPage,
                    total: totalRecords,
                    onChange: (page, size) => {
                        setCurrentPage(page);
                        getDataRegistedSevices(page, dayjs(form.getFieldValue("date")[0]).format(DATE_FORMAT.YYYYMMDDHHMMSS_FORMAT), dayjs(form.getFieldValue("date")[1]).format(DATE_FORMAT.YYYYMMDDHHMMSS_FORMAT), true, size);
                    },
                    showSizeChanger: true,
                    showTotal: (total) => `Tổng ${total} dịch vụ`,
                    pageSizeOptions: ['20', '30', '50'],
                    onShowSizeChange: (current, size) => {
                        setCurrentPageSize(size);
                        setCurrentPage(1);
                        getDataRegistedSevices(1, dayjs(form.getFieldValue("date")[0]).format(DATE_FORMAT.YYYYMMDDHHMMSS_FORMAT), dayjs(form.getFieldValue("date")[1]).format(DATE_FORMAT.YYYYMMDDHHMMSS_FORMAT), true, size);
                    }
                }}
            />

            <RegisterServiceModal
                visible={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                providers={providers}
                onSave={handleOnRegisterService}
                employees={employees}
                services={dataServices}
            />
            <ServiceDetailModal
                visible={isShowModalDetailService}
                onClose={() => setIsShowModalDetailService(false)}
                data={itemSelected}
                employees={employees}
                positions={dataPositions}
                onSave={handleSaveServiceDetail}
            />
            <LoadingBase loading={loading} />
        </div>
    )
}
export default React.memo(ManagerRegisterServicesPage);